/**
 * Environment Configuration
 * 
 * This file provides a central place for accessing environment variables
 * and provides fallbacks for development.
 */

// Development mode detection
export const isDevelopment = process.env.NODE_ENV === 'development';

// API Configuration
export const apiConfig = {
  baseUrl: process.env.VUE_APP_API_URL || '',
  timeout: parseInt(process.env.VUE_APP_API_TIMEOUT || '15000', 10)
};

// Feature Flags
export const featureFlags = {
  enableMocks: process.env.VUE_APP_ENABLE_MOCKS === 'true' || isDevelopment,
  mockTokens: process.env.VUE_APP_MOCK_TOKENS === 'true' || isDevelopment,
  bypassAuth: process.env.VUE_APP_BYPASS_AUTH === 'true' || false,
};

// Captcha Configuration - uses a testing key for development
export const captchaConfig = {
  // Google's test key if no environment variable is set
  siteKey: process.env.VUE_APP_CAPTCHA_SITE_KEY || 
          (isDevelopment ? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI' : window.captchaKey)
};

// Logging Configuration
export const loggingConfig = {
  level: process.env.VUE_APP_LOG_LEVEL || (isDevelopment ? 'debug' : 'error')
};

// Development Helpers
if (isDevelopment) {
  // Log the current configuration in development
  console.group('Environment Configuration');
  console.log('API Config:', apiConfig);
  console.log('Feature Flags:', featureFlags);
  console.log('Captcha Config:', captchaConfig);
  console.log('Logging Config:', loggingConfig);
  console.groupEnd();
} 